// Helpers to compute days until cheque due date and classify severity.
export function daysUntil(iso) {
  if (!iso) return null;
  const d = new Date(iso + "T00:00:00");
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return Math.round((d - now) / 86400000);
}

export function chequeSeverity(days) {
  if (days === null) return "unknown";
  if (days < 0) return "overdue";
  if (days === 0) return "today";
  if (days <= 3) return "urgent";
  if (days <= 7) return "soon";
  return "later";
}

// Filter cheques that should appear in the notification bell (≤7d + overdue).
export function upcomingReminders(cheques) {
  const rows = [];
  for (const c of cheques || []) {
    if ((c.status || "pending") !== "pending") continue;
    const d = daysUntil(c.due_date);
    if (d === null) continue;
    if (d <= 7) rows.push({ ...c, days: d, sev: chequeSeverity(d) });
  }
  return rows.sort((a, b) => a.days - b.days);
}
